const entry = {
  state: {
    entryReloadFlg : false,
    entryReloadId: null,
    commentReloadEntryId : null,
    
    entryEditContainerDisplay: false,
    entryEditContainerContext: {
      entry: null,
    },
    commentEditContainerDisplay: false,
    commentEditContainerContext: {
      parentEntryId: null,
      entry: null,
    },
  },
  getters: {
    entryReloadFlg(state) { return state.entryReloadFlg },
    entryReloadId(state) { return state.entryReloadId },
    commentReloadEntryId(state) { return state.commentReloadEntryId },
    entryEditContainerDisplay(state) { return state.entryEditContainerDisplay },
    entryEditContainerContext(state) { return state.entryEditContainerContext },
    commentEditContainerDisplay(state) { return state.commentEditContainerDisplay },
    commentEditContainerContext(state) { return state.commentEditContainerContext },
  },
  mutations: {
    setEntryReloadFlg(state, value) {
      state.entryReloadFlg = value
    },
    setEntryReloadId(state, value) {
      state.entryReloadId = value
    },
    setCommentReloadEntryId(state, value) {
      state.commentReloadEntryId = value
    },
    setEntryEditContainerDisplay (state, value) {
      state.entryEditContainerDisplay = value
    },
    setEntryEditContainerContext (state, value) {
      state.entryEditContainerContext = value
    },
    initEntryEditContainerContext (state) {
      state.entryEditContainerContext = {
        entry: null,
      }
    },
    setCommentEditContainerDisplay (state, value) {
      state.commentEditContainerDisplay = value
    },
    setCommentEditContainerContext (state, value) {
      state.commentEditContainerContext = value
    },
    initCommentEditContainerContext (state) {
      state.commentEditContainerContext = {
        parentEntryId: null,
        entry: null,
      }
    },
  },
  actions: {},
  modules: {}
}
export default entry